import { createFileRoute } from "@tanstack/react-router";
import { DeviceDetailPage } from "@charphq/ui/components/device/device-detail-page";
import { DeviceIdentifierResolver } from "@charphq/ui/components/device/device-identifier-resolver";

// The route param is normally an internal device UUID, but the URL may also carry
// a short code (6 digits, or CH01XXXXXX / CH02XXXXXX) or a devEUI / serial number
// for direct linking. Anything that isn't a UUID is resolved to the canonical
// device and the URL is replaced with /devices/<uuid>.
const DEVICE_UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export const Route = createFileRoute("/devices/$deviceId")({
  component: DeviceDetailComponent,
});

function DeviceDetailComponent() {
  const { deviceId } = Route.useParams();

  if (DEVICE_UUID_RE.test(deviceId)) {
    return <DeviceDetailPage deviceId={deviceId} />;
  }

  return <DeviceIdentifierResolver identifier={deviceId} />;
}
